






















import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import { sectionCoreProps } from '../mixins/sectionCore'
import SectionBasic from '../components/SectionBasic.vue'
import BlockButtons from '../components/BlockButtons.vue'
import { ButtonAction } from '../contracts/ButtonHeroAction'

export default defineComponent({
  name: 'SectionTextActions',
  components: { BlockButtons, SectionBasic },
  mixins: [sectionCoreProps],
  props: {
    description: {
      type: String,
      default: '',
    },
    actionButtons: {
      type: Array as PropType<ButtonAction[]>,
      default: () => [],
    },
    hidePaddingBottom: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const styles = computed(() => ({
      '--section-content-alignment': props.sectionData.sectionSideTitle
        ? 'flex-start'
        : 'center',
    }))

    return {
      styles,
    }
  },
})
